module.exports = __webpack_public_path__ + "static/media/salaryVector.1a9177cc.jpg";